import {DelegoRapidPayAuthorization} from '../../../../model/delego-rapidpay/delego-rapidpay-authorization';
import {PaymentError} from '../../error-handling/payment-error.enum';
import {
  DelegoRapidPayThreeDSecureInfoWithDelegoToken
} from '../../../../model/delego-rapidpay/delego-rapidpay-authenticate';
import {ConsignmentMetaData} from '../../../../model/payment/consignment-meta-data.model';

export enum DelegoActionTypes {
  AuthorizeCart = '[Delego] Authorize cart',
  AuthenticationNotRequired = '[Delego] Authentication is not required',
  AuthorizationInProcess = '[Delego] Authorization in process by Delego Silent Payment Component',
  AuthorizationSetup = '[Delego] Authorization setup',
  SetAuthenticationSuccess = '[Delego] Set authentication success',
  SetAuthenticationFailure = '[Delego] Set authentication failure',
  AuthorizationNotRequired = '[Delego] Authorization is not required',
  SetAuthorizationSuccess = '[Delego] Set authorization success',
  SetAuthorizationFailure = '[Delego] Set authorization failure',
  SetMerchantIdSuccess = '[Delego] Set merchantID success',
  ErrorOccurred = '[Delego] Error occurred',
}

export class AuthorizeCart {
  readonly type = DelegoActionTypes.AuthorizeCart;

  constructor(public payload: { cardType: string }) {
  }
}

export class AuthenticationNotRequired {
  readonly type = DelegoActionTypes.AuthenticationNotRequired;

  constructor(public payload: { consignmentCode: string; authenticationNotRequired: boolean }) {
  }
}

export class AuthenticationSuccess {
  readonly type = DelegoActionTypes.SetAuthenticationSuccess;

  constructor(public payload: {
    consignmentCode: string;
    authenticationResult: DelegoRapidPayThreeDSecureInfoWithDelegoToken;
  }) {
  }
}

export class AuthenticationFailure {
  readonly type = DelegoActionTypes.SetAuthenticationFailure;

  constructor(public payload: {
    consignmentCode: string;
    authenticationResult: DelegoRapidPayThreeDSecureInfoWithDelegoToken;
  }) {
  }
}

export class AuthorizationInProcess {
  readonly type = DelegoActionTypes.AuthorizationInProcess;
}

export class ErrorOccurred {
  readonly type = DelegoActionTypes.ErrorOccurred;

  constructor(public payload: PaymentError) {
  }
}

export class SetAuthorizationSuccess {
  readonly type = DelegoActionTypes.SetAuthorizationSuccess;

  constructor(public payload: { consignmentCode: string; authorizationResult: DelegoRapidPayAuthorization }) {
  }
}

export class SetAuthorizationFailure {
  readonly type = DelegoActionTypes.SetAuthorizationFailure;

  constructor(public payload: { consignmentCode: string; authorizationResult: DelegoRapidPayAuthorization }) {
  }
}

export class SetMerchantIdSuccess {
  readonly type = DelegoActionTypes.SetMerchantIdSuccess;

  constructor(public payload: { consignmentCode: string; merchantId: string }) {
  }
}

export class AuthorizationSetup {
  readonly type = DelegoActionTypes.AuthorizationSetup;

  constructor(public payload: { cartCode: string; consignments: ConsignmentMetaData[] }) {
  }
}

export class AuthorizationNotRequired {
  readonly type = DelegoActionTypes.AuthorizationNotRequired;
}


export type DelegoActions =
  AuthorizeCart
  | AuthenticationSuccess
  | AuthenticationNotRequired
  | AuthenticationFailure
  | AuthorizationInProcess
  | AuthorizationSetup
  | SetAuthorizationSuccess
  | SetAuthorizationFailure
  | SetMerchantIdSuccess
  | AuthorizationNotRequired
  | ErrorOccurred;
